import {Parser, word, union, maybe, sequence, delimited, proxy} from "./parser";
import AST from "./AST";
import regexpAST from "./regexpAST";
import ipv4 from "./formats/ipv4";

const W = word(/\s+/);
const MW = maybe(W);

const STAR = word("*").transform(function(match) {
    return {
        "match": new AST.Value("*"),
        "tail": match.tail
    };
});

const STRING = (function() {
    const parseJSON = JSON.parse;
    const quoted = delimited("\"").transform(function(result) {
        try {
            return {
                "match": parseJSON("\"" + result.match + "\""),
                "tail": result.tail
            };
        } catch (err) {
            if (err instanceof SyntaxError) {
                return null;
            }
            throw err;
        }
    });
    const unquoted = word(/[^<\>\/\"\(\)\!\=\s\*]+/i).pick(0);
    return union(quoted, unquoted).map(function(string) {
        return new AST.Value("string", {"string": string});
    });
})();

const NUMBER = word(/[+-]?\d+(:?\.\d+)?/).map(function(match) {
    return Number(match[0]);
}).map(function(number) {
    return new AST.Value("number", {"number": number});
});

const REGEXP = regexpAST.map(function(regexp) {
    return new AST.Value("regexp", {
        "ast": regexp.ast,
        "ignoreCase": regexp.ignoreCase
    });
});

const CIDR = new Parser({
    "match": ipv4.matchCIDR
}).map(function(cidr) {
    return new AST.Value("cidr", {
        "cidr": cidr
    });
});

const KEY = union(STAR, STRING);
const CMP_VALUE = union(NUMBER);
const EQ_VALUE = union(NUMBER, STAR, STRING, REGEXP);
const GROUP = union(CIDR);
const FUZZY = union(STAR, CIDR, NUMBER, STRING, REGEXP).map(function(match) {
    return new AST.Unary("fuzzy", match);
});

const ATOM = proxy();
const EXPR = proxy();

const PARENS = sequence(word("("), EXPR, word(")")).pick(1);
const LEFT = union(sequence(PARENS, MW), sequence(ATOM, W)).pick(0);
const RIGHT = union(PARENS, sequence(W, EXPR).pick(1));

const AND = sequence(LEFT, word(/and/i), RIGHT).pick(0, 2).map(function(match) {
    return new AST.NAry("and", match);
});

const OR = sequence(LEFT, word(/or/i), RIGHT).pick(0, 2).map(function(match) {
    return new AST.NAry("or", match);
});

const NO = sequence(
    word(/no/i),
    union(
        sequence(MW, PARENS),
        sequence(W, ATOM)
    ).pick(1)
).pick(1).map(function(match) {
    return new AST.Unary("no", match);
});

const IN = sequence(
    KEY,
    W,
    word(/not\s+in|in/i).pick(0),
    W,
    GROUP
).pick(0, 2, 4).map(function(match) {
    const key = match[0];
    const op = match[1].toLowerCase() === "in" ? "in" : "not in";
    const value = match[2];
    return new AST.Binary(op, key, value);
});

const EQ = sequence(
    KEY,
    MW,
    union(word("=="), word("="), word("!=")).pick(0),
    MW,
    EQ_VALUE
).pick(0, 2, 4).map(function(match) {
    const key = match[0];
    const op = match[1] === "!=" ? "!=" : "=";
    const value = match[2];
    return new AST.Binary(op, key, value);
});

const CMP = sequence(
    KEY,
    MW,
    union(word("<="), word(">="), word(">"), word("<")).pick(0),
    MW,
    CMP_VALUE
).pick(0, 2, 4).map(function(match) {
    const key = match[0];
    const op = match[1];
    const value = match[2];
    return new AST.Binary(op, key, value);
});

ATOM.set(union(NO, PARENS, IN, CMP, EQ, FUZZY));
EXPR.set(sequence(MW, union(AND, OR, NO, PARENS, ATOM), MW).pick(1));

export default EXPR;



// WEBPACK FOOTER //
// ./src/abusesa-js/rulesAST.js